// @ts-nocheck
export default {
	street: {
		label: 'Logradouro',
		require: true,
	},
	city: {
		label: 'Cidade',
		require: true,
	},
	state: {
		label: 'UF',
		require: true,
	},
	neighborhood: {
		label: 'Bairro',
		require: true,
	},
	cep: {
		label: 'Cep',
		require: true,
	},
	complement: {
		label: 'Complemento',
		require: false,
	},
	number: {
		label: 'Número',
		require: true,
	},
	type: {
		label: 'Tipo',
		require: true,
		options: [
			{
				label: 'Comercial',
				id: 'comercial',
			},
			{
				label: 'Residencial',
				id: 'residencial',
			},
		],
	},
};
